import * as React from "react";
import {
  ContentLayout,
  Box,
  ColumnLayout,
  Grid,
  Container,
  SpaceBetween,
  Header,
  Button
} from '@cloudscape-design/components';
import { Link } from 'react-router-dom';
import '../containers.css';
import ReactPlayer from 'react-player';
import barGraph from '../images/BarGraph.png'
import datareport from '../images/DataReport.png'
import Analytics from '../images/Analytics.png'
import Dashboard from '../images/Dashboard.png'
import OnDemand from '../images/OnDemand.png'
// import Logo from '../images/file.png'
import '@cloudscape-design/global-styles';

function MyComponent() {
  const filePath = '/Group4_Amazon_Eloquence_Commercial.mp4'; // Replace with your actual file path

  return (
    <Box>
          <ReactPlayer
            url={filePath}
            controls
          />
    </Box>
  )

  return (
    <Container
      media={{
        content: (
          <ReactPlayer
            url={filePath}
            controls
          />
        )
      }}
    >
    </Container>
  );
}


function VideoPlayer() {
  return (
    <div>
      <ReactPlayer
        url='https://youtu.be/bpcKSwRfKKE'
        controls={true}
        config={{
          youtube: {
            playerVars: {
              modestbranding: 1,
              rel: 0
            }
          }
        }}
      />
    </div>
  );
}

function AllContainers() {
  return (
    <ColumnLayout variant="text-grid" columns={4}>
      <Container>
        <Box>
          <Box variant="h2" textAlign="center">Track Progress</Box>
          <Box variant="p" textAlign="center">Visualize your history</Box>
          <Box textAlign="center"><img src={Analytics} alt="Bar Graph" /></Box>
        </Box>
      </Container>
      <Container>
        <Box>
          <Box variant="h2" textAlign="center">On-Demand</Box>
          <Box variant="p" textAlign="center">Adjust to your schedule</Box>
          <Box textAlign="center"><img src={OnDemand} alt="Bar Graph" /></Box>
        </Box>
      </Container>
      <Container>
        <Box>
          <Box variant="h2" textAlign="center">Easy To Use</Box>
          <Box variant="p" textAlign="center">Simply install an extension</Box>
          <Box textAlign="center"><img src={Dashboard} alt="Bar Graph" /></Box>
        </Box>
      </Container>
      <Container>
        <Box>
          <Box variant="h2" textAlign="center">Share Progress</Box>
          <Box variant="p" textAlign="center">Share metrics with stakeholders</Box>
          <Box textAlign="center"><img src={datareport} alt="Bar Graph" /></Box>
        </Box>
      </Container>
    </ColumnLayout>
  );
}

function FourContainers() {
  return (
    <div className="container-wrapper">
      <div className="container glowing-container-purple">
        <h2>Track Progress</h2>
        <p>Visualize your history</p>
        <div>
          <div className="image-wrapper">
            <img src={Analytics} alt="Bar Graph" />
          </div>
        </div>
      </div>
      <div className="container glowing-container-purple">
        <h2>On-demand</h2>
        <p>Adjust to your schedule</p>
        <div className="image-wrapper">
          <img src={OnDemand} alt="Computer Screen" />
        </div>
      </div>
      <div className="container glowing-container-purple">
        <h2>Easy to use</h2>
        <p>Simply install an extension</p>
        <div className="image-wrapper-1">
          <img src={Dashboard} alt="Dashboard" />
        </div>
      </div>
      <div className="container glowing-container-purple">
        <h2>Share progress</h2>
        <p>Share metrics with stakeholders</p>
        <div className="image-wrapper">
          <img src={datareport} alt="Data Report" />
        </div>
      </div>
    </div>
  );
}

function Containers() {
  return (
    <ColumnLayout columns={1} variant="text-grid">
      <Box>
        <Box variant="h2"> Why AWS Eloquence? </Box>
        <Box variant="p">
          Eloquence empowers solution architects to elevate their customer engagement skills through AI-powered feedback on customer calls.
          This innovative tool provides insights and actionable suggestions, enabling architects to refine their communication strategies and build stronger client relationships.
          Eloquence helps professionals identify areas for improvement and track their progress over time.
          Its user-friendly interface ensures seamless integration into daily workflows, allowing architects to focus on what matters most - delivering exceptional value to clients.
          With Eloquence, solution architects can continuously enhance their craft, leading to increased customer satisfaction, improved project outcomes, and ultimately, greater business success.
        </Box>
      </Box>
    </ColumnLayout>
  )
}

function OldContainers() {
  return (
    <div className="container-wrapper">
      <div className="container left-container">
        <Box
          fontSize="display-l"
          fontWeight="bold"
          variant="h1"
          padding="n"
          color="white"
        >
          Why AWS Eloquence?
        </Box>
        <p>Eloquence empowers solution architects to elevate their customer engagement skills through AI-powered feedback on customer calls.
          This innovative tool provides insights and actionable suggestions, enabling architects to refine their communication strategies and build stronger client relationships.
          Eloquence helps professionals identify areas for improvement and track their progress over time.
          Its user-friendly interface ensures seamless integration into daily workflows, allowing architects to focus on what matters most - delivering exceptional value to clients.
          With Eloquence, solution architects can continuously enhance their craft, leading to increased customer satisfaction, improved project outcomes, and ultimately, greater business success.</p>
      </div>
      <div className="container right-container">

        <MyComponent />
      </div>
    </div>
  );
}


function HeaderLearnMore() {
  return (
    <ContentLayout
      defaultPadding
      disableOverlap
      headerBackgroundStyle={mode =>
        `center center/cover url("../images/BarGraph-${mode}.png")`
      }
    >
      <SpaceBetween direction="vertical" size="xl">
        {/* First Container */}
        <Box
          backgroundColor="#1E90FF"
          padding={{ vertical: "xxxl" }}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Container>
            <Box textAlign="center"
            >
              <Box
                fontSize="display-l"
                fontWeight="bold"
                variant="h1"
                padding="n"
                color="white"
              >
                AWS Eloquence
              </Box>
              <Box
                fontSize="display-l"
                fontWeight="light"
                color="white"
              >
                The AI powered presentation coach
              </Box>
              <Box
                variant="p"
                color="text-body-secondary"
                margin={{ top: "xs", bottom: "l" }}
              >
                Boost presentation skills and enhance customer relationships.
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                margin={{ top: "l" }}
              >
                <Link to='/getstarted'>
                  <Button variant="primary">
                    Get Started Today
                  </Button>
                </Link>
              </Box>
            </Box>
          </Container>
        </Box>

        {/* Container Row */}
        <Box
          display="flex"
          justifyContent="center"
          marginTop="xxl"
        >
          {/* Second Container */}
          <Box
            //backgroundColor="#0f141a"
            padding={{ vertical: "xl" }}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            marginRight="l"
          >
          </Box>
          <div className="two-containers-wrapper">
            <Containers />
          </div>

          <Box height="xxxxl" />
          <Box
            fontSize="display-l"
            fontWeight="bold"
            variant="h1"
            padding="n"
            color="white"

          >
            <br></br>
            Benefits of AWS Eloquence
          </Box>
          <div className="four-containers-wrapper">
            <AllContainers></AllContainers>
          </div>
        </Box>
      </SpaceBetween>
    </ContentLayout>
  );
}

export default HeaderLearnMore;
